import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideQueryClientOptions } from '@ngneat/query';
import { provideQueryDevTools } from '@ngneat/query-devtools';
import { APP_CONFIG, TnrAuthProviderModule, TnrAuthProviderService } from '@tnr/ng-oauth2';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth-interceptor';
import { refreshTokenInterceptor } from './interceptors/refresh-token.interceptor';
import { OnePlaceHeaderModule, OnePlaceHeaderService } from '@tnr/oneplace-header';
import { provideAnimations } from '@angular/platform-browser/animations';
import { base64EncodingInterceptor } from './interceptors/base64-encoding.interceptor';
import { refreshTnRTokenInterceptor } from './interceptors/refresh-tnr-token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    importProvidersFrom(
      TnrAuthProviderModule.forRoot(environment.colab.authConfig, environment.colab.authModuleConfig),
      OnePlaceHeaderModule
    ),
    {
      provide: APP_CONFIG,
      useValue: environment.colab.tnrAuthConfig
    },
    provideHttpClient(
      withInterceptors([authInterceptor, refreshTokenInterceptor, refreshTnRTokenInterceptor, base64EncodingInterceptor])
    ),
    provideQueryClientOptions({
      defaultOptions: {
        queries: {
          gcTime: 0,
          refetchOnWindowFocus: false,
          staleTime: 0
        }
      }
    }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled'
      })
    ),
    environment.production ? [] : provideQueryDevTools(),
    {
      provide: APP_INITIALIZER,
      useFactory: loadTnrPreAuth,
      multi: true,
      deps: [TnrAuthProviderService, OnePlaceHeaderService]
    }
  ]
};

function loadTnrPreAuth(
  authProviderService: TnrAuthProviderService,
  onePlaceHeaderService: OnePlaceHeaderService
): () => Promise<void> {
  return async () => {
    await onePlaceHeaderService.loadOnePlaceScript({
      onePlaceUrl: environment.colab.oneplaceUrl
    });
    return authProviderService.loadDiscoveryDocument();
  };
}
